import Zoom from '@mui/material/Zoom';
import { FilledStarIcon, EmptyStarIcon, BoxStar } from './styles';

interface DivStarProps {
  fav: boolean;
  onChange: () => void;
}

export function DivStar({ fav, onChange }: DivStarProps): JSX.Element {
  return (
    <BoxStar onClick={onChange}>
      {fav ? (
        <Zoom in style={{ transitionDelay: '80ms' }}>
          <FilledStarIcon />
        </Zoom>
      ) : (
        <EmptyStarIcon />
      )}
    </BoxStar>
  );
}
